import React from "react";

const LineCrudTableSearch = ({
        setFind, 
        listLinesByNumberLine,
        listLinesByNumberDocumentOfClient,
        validateInputOfSearch,
        formRef,
    }) => {

    const handleChange = (e) => {
        //setForm({...form, [e.target.name]: e.target.value});
        setFind({[e.target.name]: e.target.value});
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        var optionSelected = parseInt(document.querySelector('#busqueda').value);
        if (optionSelected === 1) {
            listLinesByNumberLine();
        }else if (optionSelected === 2) {
            listLinesByNumberDocumentOfClient();
        }else if (optionSelected === 0) {
            validateInputOfSearch();
        }        
    }

    return (
        <div>    
            <div className="row mb-2">
                <h6>Busqueda de Líneas</h6>
            </div>
            <div className="table-responsive rounded-3 d-flex justify-content-center" style={{border:'1px solid black'  , paddingTop:'15px'}}>
                <>
                    <form className="row g-3" ref={formRef}>
                        <div className="col-auto">
                            <select id="busqueda" className="form-select" aria-label="Default select example">
                                <option value="0">Seleccione</option>
                                <option value="1">Número de Línea</option>
                                <option value="2">Número de documento de Cliente</option>
                            </select>
                        </div>
                        <div className="col-auto">
                            <input type="number" className="form-control" id="find" name="find" onChange={handleChange}/>
                        </div>
                        <div className="col-auto">
                            <button type="submit" className="btn btn-primary mb-3" onClick={handleSubmit}>Buscar</button>
                        </div>
                    </form> 
                </>
            </div>
        </div>
    );
}
export default LineCrudTableSearch;